/**
 * Tables transferred in device-to-device P2P transfer (client-writable subset
 * of `USER_DATA_TABLES`; insertion order: parents before children).
 *
 * Excludes `entry_version`. Version history is
 * server-materialized (`maybe_snapshot_entry_version` in the write-path) and
 * READ-ONLY on the client — it arrives via the `entry_versions` stream. The server
 * re-derives it upon receiving imported entries; transferring it would create local
 * rows the client cannot upload. `USER_DATA_TABLES` does include it (to sweep it
 * on logout and count it), but the transfer must NOT move it.
 */
export const P2P_TRANSFER_TABLES = [
  "journal_entry",
  "journal_tag",
  "journal_entry_tag",
  "attachment",
] as const;
